import gsap, { CSSRulePlugin } from '@ptchr/gsap/all';
gsap.registerPlugin(CSSRulePlugin)


window.addEventListener('load', () => {
	// const tl = gsap.timeline({ repeat: -1 });

	// var rule = CSSRulePlugin.getRule('.count-wrapper .a-attr-circle::before')

	// tl.to(document.querySelector('.count-wrapper .a-attr-circle'), {
	// 	duration: 3,
	// 	scale: 3
	// });
})



// WEBPACK FOOTER //
// ./js/modules/animations/pulse.js